import React, { useState, useEffect, useContext } from 'react';
import { Breadcrumb, Card, Col, Row, Tabs } from "antd";
import Icofont from "react-icofont";
import { errorCatch, READ, uncapitalize } from '../../components/Tool';
import { Link, Route, useRouteMatch } from "react-router-dom";
import { useUserContext } from '../../components/Context';
import { useAuth } from '../../components/Auth';
import AbstractCollection from '../../components/AbstractCollection';
import Model from '../../components/Model';
import { useSelector } from 'react-redux';

const { TabPane } = Tabs;

export default function SystemAnswers(props) {
    const auth = useAuth();
    const user = useUserContext();

    const meta = useSelector(state => state.meta);
    const objMeta = (meta)?meta["answers"]:undefined;

    console.log(objMeta);
    return (<>
        <Breadcrumb style={{ margin: '16px 16px' }}>
            <Breadcrumb.Item>Система</Breadcrumb.Item>
            <Breadcrumb.Item>Ответы</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{ padding: 12, minHeight: 360, backgroundColor: "white", height:"100%" }}>
            <Col span={24}>
                <Card size="small" bordered={false}>
                    {objMeta && <AbstractCollection
                        auth={auth}
                        detail="model"
                        name={objMeta.name}
                        columns={() => [
                            {
                                key: 1,
                                title: "Ответ",
                                render: (text, record, index) => {
                                    return (record.name);
                                }
                            },
                            {
                                key: 2,
                                title: "Вопрос",
                                render: (text, record, index) => {
                                    return (record.question.title);
                                }
                            }
                        ]}
                        
                        form={Model}
                        meta={objMeta.properties}
                    />}
                    {/* <Tabs defaultActiveKey="1">
                        {["services"].map((e,idx) => { 
                            let metaObj = meta[e];
                            if(!metaObj) {
                                return;
                            }
                            return (<TabPane tab={metaObj.label} key={idx}>
                                <AbstractCollection
                                    auth={auth}
                                    name={metaObj.name}
                                    columns={() => metaObj.properties.filter(n=>n.type === "string").map(n=>({
                                        title: n.label,
                                        render: (text, record, index) => {
                                            return (record[uncapitalize(n.name)]);
                                        }
                                    }))}
                                    form={Model}
                                    meta={metaObj.properties}
                                />
                            </TabPane>
                        )})}
                    </Tabs> */}
                </Card>
            </Col>
        </div>
    </>);
}